import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'extension-edit-loader',
  templateUrl: './extension-edit-loader.component.html',
  styleUrls: ['./extension-edit-loader.component.scss'],
  standalone: false,
})
export class ExtensionEditLoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
